import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { Observable } from 'rxjs';
import { PackageService } from '@services/packages/package.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { TranslateService } from '@services/translate/translate.service';
import { DialogService } from '@services/dialog/dialog.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { PrivilegeGuard } from '../../../guards/privilege.guard';
import { QueService } from '@services/que/que.service';

@Component({
    selector: 'app-package-legal',
    templateUrl: './package-legal.component.html',
    styleUrls: ['./package-legal.component.scss'],
    providers: [PackageService, QueService],
    standalone: false
})
export class PackageLegalComponent implements OnInit, OnDestroy {

  public packageId;
  public myPackage: Models.Package;

  public messages;

  @Input() onSave: Observable<any>;
  @Input() noHeader = false;
  public submitRequest = false;
  public availableLanguages = ['de'];
  public currentLang;
  public currentLangAGB;
  public currentLangImprint;
  private subscription: any;
  pageActions: any;

  constructor(
    private route: ActivatedRoute, private snackbar: SnackbarService, private packageService: PackageService, private ts: TranslateService, private dialogService: DialogService,
    private priv: PrivilegeGuard, private que: QueService
  ) {
    this.pageActions = [ new PageAction({ icon: 'save', title: '', translationString: 'general.save', callback: () => { this.save(); } }), new PageAction({
      icon: 'language', title: '', translationString: 'general.queuePriority', hidden: !this.priv.checkIfPrivilege('write', 'packages'),
      callback: () => { this.que.triggerPriority(this.packageId); }
    }) ];
  }

  async ngOnInit() {
    this.messages = this.ts.get('system');
    this.packageId = this.route.snapshot.params['id'];
    this.initPackage();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  public tabChange(event) {
    this.currentLang = this.availableLanguages[event.index];
  }

  public tabChangeAGB(event) {
    this.currentLangAGB = this.availableLanguages[event.index];
  }

  public tabChangeImprint(event) {
    this.currentLangImprint = this.availableLanguages[event.index];
  }

  public onEditorChange(value, key, lang) {
    this.myPackage.legal[key]['text'][lang] = value;
  }

  public async save() {
    this.myPackage.legal.dsgvo = this.cleanUpQuillContent(this.myPackage.legal.dsgvo);
    this.myPackage.legal.agb = this.cleanUpQuillContent(this.myPackage.legal.agb);
    this.myPackage.legal.imprint = this.cleanUpQuillContent(this.myPackage.legal.imprint);

    await this.packageService.update(this.myPackage._id, this.myPackage);
    this.submitRequest = false;
    this.snackbar.success(this.messages.general.savedChanges, 2000);
  }

  public addAGB() {
    this.myPackage.legal.agb = new Models.LegalItem();
    this.initLegalItem(this.myPackage.legal.agb);
    this.tabChangeAGB({ index: 0 });
  }

  public async removeAGB() {
    const res = await this.dialogService.confirm(this.messages.packages.removeAGB);
    if (!res) {
      return
    }
    this.myPackage.legal.agb = null;
  }

  public addImprint() {
    this.myPackage.legal.imprint = new Models.LegalItem();
    this.initLegalItem(this.myPackage.legal.imprint);
    this.tabChangeImprint({ index: 0 });
  }

  public async removeImprint() {
    const res = await this.dialogService.confirm(this.messages.packages.removeImprint);
    if (!res) {
      return
    }
    this.myPackage.legal.imprint = null;
  }

  private async initPackage() {
    const myPackage = await this.packageService.get(this.packageId);
    this.myPackage = myPackage;
    this.availableLanguages = myPackage.availableLanguagesCached?.length ? myPackage.availableLanguagesCached : this.availableLanguages;
    if (!this.myPackage.legal) {
      this.myPackage.legal = new Models.Legal();
      this.myPackage.legal.dsgvo = new Models.LegalItem();
    }
    this.initLegalItem(this.myPackage.legal.dsgvo);
    this.tabChange({ index: 0 });
    if (this.myPackage.legal.agb) {
      this.tabChangeAGB({ index: 0 });
    }
    if (this.myPackage.legal.imprint) {
      this.tabChangeImprint({ index: 0 });
    }
  }

  private initLegalItem(item) {
    item['url'] = item['url'] || {};
    item['text'] = item['text'] || {};
    this.availableLanguages.map(lang => {
      if (!item['url'][lang]) {
        item['url'][lang] = '';
      }
      if (!item['text'][lang]) {
        item['text'][lang] = '';
      }
    });
    return item;
  }

  private cleanUpQuillContent(item) {
    if (!item) {
      return item;
    }
    this.availableLanguages.map(lang => {
      if (item['text'] && item['text'][lang]) {
        while (item['text'][lang].match(/<p>(<\w*>)*(<br>)*(<\/\w*>)*<\/p>$/gm)) {
          item['text'][lang] = item['text'][lang].replace(/<p>(<\w*>)*(<br>)*(<\/\w*>)*<\/p>$/gm, ''); // removes unused end-spaces
        }
      }
    });
    return item;
  }
}
